import React from "react";
import AboutSection from "../components/AboutSection";
import Timeline from "../components/Timeline";
import SubBrands from "../components/SubBrands";

export default function AboutUs() {
  return (
    <div>
      <AboutSection />
      <Timeline />
      <SubBrands />
    </div>
  );
}
